import {Grid, Typography} from '@yandex-delivery/blocks'

import {Body, EmailInput, NameInput, PhoneInput, SmsCodeSwitch, ToggleTitle} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {usePointContactsExpress} from './hooks'
import type {Props} from './types'

export function PointContact(props: Props) {
  const {isSmsConfirmationEnabled = false, isDetailsToggleHidden = false, title} = props
  const {isContactDetailsVisible, contactDetailsVisibilityHandler, contactsCaption, names, handlePhoneInputFocus} =
    usePointContactsExpress(props)

  return (
    <Body
      lead={
        <>
          <Typography group="tight" mt={isDetailsToggleHidden ? 'm' : 's'} thickness="medium" variant="body2">
            {title}
          </Typography>
          {isDetailsToggleHidden ? null : (
            <ToggleTitle
              data-e2e="contact-details"
              isOpened={isContactDetailsVisible}
              onClick={contactDetailsVisibilityHandler}
              title={i18n('cargo.create.address.details', 'Детали')}
            />
          )}
        </>
      }
      tail={
        <Grid container>
          <Grid xs={12} item>
            <PhoneInput
              data-testid={`phone_${names.phone}`}
              helperText={isContactDetailsVisible ? undefined : contactsCaption}
              name={names.phone}
              onFocus={handlePhoneInputFocus}
            />
          </Grid>
          {(isContactDetailsVisible || isDetailsToggleHidden) && (
            <Grid xs={12} item>
              <Grid size="s" container>
                <Grid xs={6} item>
                  <NameInput data-testid={`phone_${names.name}`} name={names.name} />
                </Grid>
                <Grid xs={6} item>
                  <EmailInput data-testid={`phone_${names.email}`} name={names.email} />
                </Grid>
                {isSmsConfirmationEnabled && (
                  <Grid xs={12} item>
                    <SmsCodeSwitch name={names.isSmsConfirmationEnabled} />
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
      }
    />
  )
}
